import * as React from 'react';

import NewUserTab from './tab';
import Users from './Users';
import InvitedUser from './InvitedUser';

const NewProject: React.SFC<unknown> = () => {
    const [toggleCurrentUsers, setToggleCurrentUsers] = React.useState(true);
    return (
        <div className="project-add--container">
            <div className="project-add--wrapper no-box-shadows">
                <NewUserTab
                    setToggleCurrentUsers={(index) =>
                        setToggleCurrentUsers(index)
                    }
                    toggleCurrentUsers={toggleCurrentUsers}
                />
                {toggleCurrentUsers ? <Users /> : <InvitedUser />}
            </div>
        </div>
    );
};

export default NewProject;
